import { Typography } from '@material-ui/core'
import PeopleIcon from '@material-ui/icons/People'

import { getTranslate } from '../../localization'
import useStyles from './styles/SearchWidgetGuests.styles'

interface SearchWidgetGuestsProps {
  guestsNumber: number
}
const SearchWidgetGuests: React.FC<SearchWidgetGuestsProps> = ({
  guestsNumber: guestNumber
}) => {
  const classes = useStyles()
  return (
    <div className={classes.root}>
      <div className={classes.labelHeader}>
        <PeopleIcon className={classes.icon} />
        <Typography variant="h4" className={classes.title}>
          {getTranslate('Guest')}
        </Typography>
      </div>
      <div className={classes.guestsInfoContainer}>
        {/* <div className={classes.numberOfAdultsContainer}>
          <Typography variant="h5" color="primary" className={classes.number}>
            1
          </Typography>
        </div>
        <div className={classes.adultLabelContainer}>
          <Typography variant="h5" className={classes.text}>
            {getTranslate('Room')}
          </Typography>
        </div> */}
        {/* <div className={classes.commaContainer}>
          <Typography variant="h5">{getTranslate(',')}</Typography>
        </div> */}
        <div className={classes.numberOfAdultsContainer}>
          <Typography variant="h5" color="primary" className={classes.number}>
            {guestNumber}
          </Typography>
        </div>
        <div className={classes.numberOfRoomText}>
          <Typography variant="h5" className={classes.text}>
            {getTranslate('Adults')}
          </Typography>
        </div>
      </div>
    </div>
  )
}
export default SearchWidgetGuests
